import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ButtonContainer,
  ContentContainer,
  MessageContainer
} from 'Pages/updatePassword/components/error/style';
import { Button, ButtonSizes, ButtonWidth } from 'Shared/components/design/button/Button';

type ErrorProps = {
  signInRedirect: () => void;
}

/**
 * Renders Error slide
 */
function Error({ signInRedirect }: ErrorProps): JSX.Element {
  const { t } = useTranslation('updatePassword');

  return(
    <ContentContainer>
      <MessageContainer>
        {t('UpdatePassword--error-message')}
      </MessageContainer>
      <ButtonContainer>
        <Button
          size    = {ButtonSizes.LARGE}
          width   = {ButtonWidth.FULL}
          onClick = {signInRedirect}
        >
          {t('UpdatePassword--error-buttonLabel')}
        </Button>
      </ButtonContainer>
    </ContentContainer>
  );
}

export default Error;

